import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CheckoutType} from '@gatewee/types/checkout';

@Pipe({
  name: 'checkoutType',
  pure: false,
  standalone: false,
})
export class CheckoutTypePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: CheckoutType | string): string {
    return (
      this.translate.instant(`enums.checkoutType.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
